<template>
  <div>
    <Loading v-if="initialLoad"></Loading>
    <Layout v-else>
      <section class="pt-5">
        <div>
          <b-tabs active-nav-item-class="top-agent-active" content-class="mt-3">
            <b-tab class="pl-0" title="Pinpad Transactions">
              <TopAgentsTable>
                <span slot="entries-no">
                  {{ topPinpadEntriesShown }} of
                  {{ topPinpadTotalEntries }}
                  {{ topPinpadTotalEntries === 1 ? "entry" : "entries" }}
                </span>
                <b-table
                  slot="table"
                  sticky-header
                  hover
                  :busy="topPinpadIsBusy"
                  :per-page="perPage"
                  :items="topPinpadData"
                >
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle mr-1"></b-spinner>
                      <strong>Loading...</strong>
                    </div>
                  </template>
                  <template #head(realId)="data">
                    <span>{{ (data = "Agent ID") }}</span>
                  </template>
                  <template #head(count)="data">
                    <span>{{ (data = "Transaction Volume") }}</span>
                  </template>
                </b-table>
                <b-pagination-nav
                  slot="pagination"
                  class="d-flex justify-content-end"
                  :class="{ 'rc-pagination': rcPagination }"
                  :link-gen="topPinpadLinkGen"
                  :number-of-pages="topPinpadTotalPages"
                  :disabled="topPinpadIsBusy"
                  prev-text="Previous"
                  next-text="Next"
                  use-router
                  @change="removeClass"
                ></b-pagination-nav>
              </TopAgentsTable>
            </b-tab>
            <b-tab title="POS Transactions">
              <TopAgentsTable>
                <span slot="entries-no">
                  {{ topPosEntriesShown }} of
                  {{ topPosTotalEntries }}
                  {{ topPosTotalEntries === 1 ? "entry" : "entries" }}
                </span>
                <b-table
                  slot="table"
                  sticky-header
                  hover
                  :busy="topPosIsBusy"
                  :items="topPosData"
                >
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle mr-1"></b-spinner>
                      <strong>Loading...</strong>
                    </div>
                  </template>
                  <template #head(realId)="data">
                    <span>{{ (data = "Agent ID") }}</span>
                  </template>
                  <template #head(count)="data">
                    <span>{{ (data = "Transaction Volume") }}</span>
                  </template>
                </b-table>
                <b-pagination-nav
                  slot="pagination"
                  class="d-flex justify-content-end"
                  :link-gen="topPosLinkGen"
                  :number-of-pages="topPosTotalPages"
                  :disabled="topPosIsBusy"
                  prev-text="Previous"
                  next-text="Next"
                  use-router
                  @change="removeClass"
                ></b-pagination-nav>
              </TopAgentsTable>
            </b-tab>
            <!-- <b-tab title="Bank Transfer">
              <TopAgentsTable>
                <span slot="entries-no">
                  {{ topTransferEntriesShown }} of
                  {{ topTransferTotalEntries }}
                  {{ topTransferTotalEntries === 1 ? "entry" : "entries" }}
                </span>
                <b-table
                  slot="table"
                  sticky-header
                  hover
                  :busy="topTransferIsBusy"
                  :items="topTransferData"
                >
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle mr-1"></b-spinner>
                      <strong>Loading...</strong>
                    </div>
                  </template>
                </b-table>
                <b-pagination-nav
                  slot="pagination"
                  class="d-flex justify-content-end"
                  :link-gen="topTransferLinkGen"
                  :number-of-pages="topTransferTotalPages"
                  :disabled="topTransferIsBusy"
                  prev-text="Previous"
                  next-text="Next"
                  use-router
                  @change="removeClass"
                ></b-pagination-nav>
              </TopAgentsTable>
            </b-tab> -->
            <b-tab title="Account Opening">
              <TopAgentsTable>
                <span slot="entries-no">
                  {{ topAccountEntriesShown }} of
                  {{ topAccountTotalEntries }}
                  {{ topAccountTotalEntries === 1 ? "entry" : "entries" }}
                </span>
                <b-table
                  slot="table"
                  sticky-header
                  hover
                  :busy="topAccountIsBusy"
                  :items="topAccountData"
                >
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle mr-1"></b-spinner>
                      <strong>Loading...</strong>
                    </div>
                  </template>
                  <template #head(agent_code)="data">
                    <span>{{ (data = "Agent ID") }}</span>
                  </template>
                </b-table>
                <b-pagination-nav
                  slot="pagination"
                  class="d-flex justify-content-end"
                  :link-gen="topAccountLinkGen"
                  :number-of-pages="topAccountTotalPages"
                  :disabled="topAccountIsBusy"
                  prev-text="Previous"
                  next-text="Next"
                  use-router
                  @change="removeClass"
                ></b-pagination-nav>
              </TopAgentsTable>
            </b-tab>
          </b-tabs>
        </div>
      </section>
    </Layout>
  </div>
</template>

<script>
import Loading from "@/components/Loading.vue";
import Layout from "@/components/Layout.vue";
import TopAgentsTable from "@/components/TopAgentsTable.vue";
import { mapState, mapActions } from "vuex";
import { appDataMixin } from "@/mixins/appData";

export default {
  name: "TopAgents",
  mixins: [appDataMixin],
  components: {
    Loading,
    Layout,
    TopAgentsTable,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      initialLoad: (state) => state.topAgents.initialLoad,
      loading: (state) => state.topAgents.loading,
      refresh: (state) => state.topAgents.refresh,

      topPinpadIsBusy: (state) => state.topAgents.topPinpadIsBusy,
      topPosIsBusy: (state) => state.topAgents.topPosIsBusy,
      topTransferIsBusy: (state) => state.topAgents.topTransferIsBusy,
      topAccountIsBusy: (state) => state.topAgents.topAccountIsBusy,

      topPinpadTotalPages: (state) => state.topAgents.topPinpad.last_page,
      topPosTotalPages: (state) => state.topAgents.topPos.last_page,
      topTransferTotalPages: (state) => state.topAgents.topTransfer.last_page,
      topAccountTotalPages: (state) => state.topAgents.topAccount.last_page,

      topPinpadTotalEntries: (state) => state.topAgents.topPinpad.total,
      topPosTotalEntries: (state) => state.topAgents.topPos.total,
      topTransferTotalEntries: (state) => state.topAgents.topTransfer.total,
      topAccountTotalEntries: (state) => state.topAgents.topAccount.total,

      topPinpadEntriesShown: (state) =>
        state.topAgents.topPinpad.to !== null
          ? state.topAgents.topPinpad.to
          : 0,
      topPosEntriesShown: (state) =>
        state.topAgents.topPos.to !== null ? state.topAgents.topPos.to : 0,
      topTransferEntriesShown: (state) =>
        state.topAgents.topTransfer.to !== null
          ? state.topAgents.topTransfer.to
          : 0,
      topAccountEntriesShown: (state) =>
        state.topAgents.topAccount.to !== null
          ? state.topAgents.topAccount.to
          : 0,

      topPinpadData: (state) => {
        if (state.topAgents.topPinpad.data.length === 0) {
          return [
            {
              No_data: "No data to be displayed",
            },
          ];
        } else {
          return state.topAgents.topPinpad.data;
        }
      },
      topPosData: (state) => {
        if (state.topAgents.topPos.data.length === 0) {
          return [
            {
              No_data: "No data to be displayed",
            },
          ];
        } else {
          return state.topAgents.topPos.data;
        }
      },
      topTransferData: (state) => {
        if (state.topAgents.topTransfer.data.length === 0) {
          return [
            {
              No_data: "No data to be displayed",
            },
          ];
        } else {
          return state.topAgents.topTransfer.data;
        }
      },
      topAccountData: (state) => {
        if (state.topAgents.topAccount.data.length === 0) {
          return [
            {
              No_data: "No data to be displayed",
            },
          ];
        } else {
          return state.topAgents.topAccount.data;
        }
      },
    }),
  },
  methods: {
    ...mapActions({
      topPinpad: "topAgents/getTopPinpad",
      topPos: "topAgents/getTopPos",
      topTransfer: "topAgents/getTopTransfer",
      topAccount: "topAgents/getTopAccount",
    }),
    topPinpadLinkGen(pageNum) {
      return `?page=${pageNum}`;
    },
    topPosLinkGen(pageNum) {
      return `?page=${pageNum}`;
    },
    topTransferLinkGen(pageNum) {
      return `?page=${pageNum}`;
    },
    topAccountLinkGen(pageNum) {
      return `?page=${pageNum}`;
    },
    getTodayData() {
      this.topPinpad({
        startDate: this.today,
        endDate: this.today,
        page: this.page ? this.page : 1,
      });
      this.topPos({
        startDate: this.today,
        endDate: this.today,
        page: this.page ? this.page : 1,
      });
      this.topTransfer({
        startDate: this.today,
        endDate: this.today,
        page: this.page ? this.page : 1,
      });
      this.topAccount({
        startDate: this.today,
        endDate: this.today,
        page: this.page ? this.page : 1,
      });
    },
  },
  created() {
    document.title = "Top Agents | ReadyCash Aggregator Portal";
  },
};
</script>

<style></style>
